import {
  BottomSheet,
  BottomSheetLoadingContent,
  type UseModalState,
} from "@clipboard-health/ui-components";

import { AcceptNonInstantPayContent } from "../../Timekeeping/TimekeepingActions/AcceptNonInstantPayContent";

interface AcceptNonInstantPayBottomSheetProps {
  modalState: UseModalState;
  isConvertingToNonInstantPay: boolean;
  onAccept: () => Promise<void>;
  onCancel: () => void;
  workplaceName: string;
  isMissedPunchRequestEnabled: boolean;
}

export function AcceptNonInstantPayBottomSheet(props: AcceptNonInstantPayBottomSheetProps) {
  const {
    modalState,
    isConvertingToNonInstantPay,
    onAccept,
    onCancel,
    workplaceName,
    isMissedPunchRequestEnabled,
  } = props;

  return (
    <BottomSheet modalState={modalState} canDismiss={false}>
      {isConvertingToNonInstantPay ? (
        <BottomSheetLoadingContent
          title="Converting to non-instant pay"
          description="Should only take a few seconds"
        />
      ) : (
        <AcceptNonInstantPayContent
          workplaceName={workplaceName}
          isMissedPunchRequestEnabled={isMissedPunchRequestEnabled}
          onAccept={onAccept}
          onCancel={onCancel}
        />
      )}
    </BottomSheet>
  );
}
